import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

const MENU = {
  title: 'The Full Vibe Menu',
  subtitle: 'Ice Cream Vibes • One Bean. Infinite Vibes • Drinks • Snacks & Treats',
  image: 'https://static.wixstatic.com/media/720c8e_2b3a39793c3246d5a2c6c5e505be1c2b~mv2.png/v1/fill/w_900,h_1342,al_c,q_90,enc_avif,quality_auto/720c8e_2b3a39793c3246d5a2c6c5e505be1c2b~mv2.png'
};

const scrollToId = (id) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(`#${id}`, { offset: -72 });
  } else {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }
};

const Menu = () => {
  return (
    <section id="menu" data-testid="menu-section" className="bg-[#1d1712] px-6 py-24 sm:px-12 sm:py-32">
      <div className="mx-auto max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-body text-[11px] font-medium uppercase tracking-[0.45em] text-[#f2a33c]">
            The Menu
          </p>
          <h2 className="font-display mt-4 text-[clamp(2.6rem,6vw,4.5rem)] font-semibold leading-[1.02] tracking-tight text-[#f4ede3]">
            One bean. <span className="italic text-[#f2a33c]">Infinite vibes.</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="mt-14 overflow-hidden rounded-2xl border border-[#f4ede3]/10 bg-[#14100d]"
        >
          {/* Menu header */}
          <div className="flex items-center justify-center gap-3 border-b border-[#f4ede3]/10 px-6 py-5">
            <Sparkles size={22} className="text-[#f2a33c]" />
            <div className="text-center">
              <h3 data-testid="menu-item-title" className="font-display text-2xl font-semibold text-[#f4ede3]">
                {MENU.title}
              </h3>
              <p className="font-body text-xs text-[#b8ac9c] sm:text-sm">{MENU.subtitle}</p>
            </div>
          </div>

          {/* Menu image */}
          <div className="bg-[#0d0a08]">
            <img
              data-testid="menu-item-image"
              src={MENU.image}
              alt={MENU.title}
              loading="lazy"
              className="mx-auto max-h-[760px] w-full object-contain"
            />
          </div>

          {/* Menu footer */}
          <div className="border-t border-[#f4ede3]/10 px-6 py-6 text-center">
            <p className="font-body text-sm text-[#b8ac9c]">
              <span className="font-semibold text-[#f4ede3]">One Bean. Infinite Vibes.</span> · Powered by Bruster's Ice Cream
            </p>
            <p className="font-display mt-1 text-lg italic text-[#f2a33c]">Don't just order... tap into the Vibe.</p>
            <div className="mt-5 flex flex-col justify-center gap-3 sm:flex-row">
              <button data-testid="menu-visit-button" className="btn-pill font-body" onClick={() => scrollToId('contact')}>
                Visit Us Today
              </button>
              <button data-testid="menu-book-button" className="btn-pill-outline font-body" onClick={() => scrollToId('booking')}>
                Book an Event
              </button>
            </div>
          </div>
        </motion.div>

        <p className="font-body mt-10 text-center text-sm text-[#b8ac9c]">
          <span className="font-semibold text-[#f2a33c]">Weekly Vibe Drop:</span> ask what's unlocking this week.
        </p>
      </div>
    </section>
  );
};

export default Menu;
